import React from 'react';
import {
  Button,
  ButtonElevation,
  ButtonSize,
  ButtonType,
} from '@prisjakt/ui/button';
import { Behavior } from '@prisjakt/ui/text';
import { getFractalRepresentation } from './utils';
import type { IVariantSelectionButton } from '../types';
import { SelectionButtonText } from './styles';

export const SizeVariantSelectionButton: React.FC<
  IVariantSelectionButton
> = props => {
  const { variant, title, selection, disabled, handleSelection, isMobile } =
    props;
  const sizeWithFractal = title ? getFractalRepresentation(title) : '';
  const isSelected = Boolean(
    (variant && selection?.includes(variant)) || (!variant && !selection)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <Button
      onClick={onSelect}
      selectable
      selected={isSelected}
      fullWidth
      type={ButtonType.OUTLINED}
      elevation={ButtonElevation.NONE}
      disabled={disabled}
      size={isMobile ? ButtonSize.NORMAL : ButtonSize.SMALL}
    >
      <SelectionButtonText behavior={Behavior.OnelineEllipsis}>
        {sizeWithFractal}
      </SelectionButtonText>
    </Button>
  );
};
